'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('TrackingPropriedadeCtrl', function($scope,
  TrackingService, VisitaCampoService, MessagesService, LoadingService, $routeParams, LeafletService) {
  $scope.gTrackings = {};

  $scope.removeAllTrackings = function() {
    Object.keys($scope.gTrackings).forEach(function(key) {
      $scope.gTrackings[key].forEach(function(tracking) {
        if ($scope.map) {
          return tracking.setMap(null);
        }
        tracking.forEach(function(item) {
          item.remove();
        });
      });
    });
    $scope.gTrackings = {};
  };

  $scope.setTracking = function(tracking, event) {
    const filters = {
      gleba: { id: $scope.gleba || $routeParams.activeGleba },
      dia: $routeParams.historyDate || $routeParams.date,
      usuario: tracking.id,
      cor: `#${ tracking.cor}`
    };

    event.preventDefault();
    tracking.active = !tracking.active;
    if (tracking.active) {
      LoadingService.showLoading();
      loadTrackings(tracking, filters)
        .catch(() => {
          MessagesService.alert('Não foi possível carregar o caminhamento');
          tracking.active = false;
        })
        .finally(LoadingService.hideLoading);
    } else if ($scope.gTrackings[tracking.id]) {
      $scope.gTrackings[tracking.id].forEach(function(gTracking) {
        if ($scope.map) {
          return gTracking.setMap(null);
        }
        gTracking.forEach(function(item) {
          item.remove();
        });
      });
      $scope.gTrackings[tracking.id] = [];
    }
  };

  function loadTrackings(tracking, filters) {
    return VisitaCampoService.newGetTrackingsDayGleba(filters).then(function(trackings) {
      if (trackings.length < 1 || trackings.every(({ path }) => path.length < 4)) {
        tracking.active = false;
        MessagesService.alert('Pontos insuficientes para desenhar o caminhamento.');
      } else {
        $scope.gTrackings[tracking.id] = trackings.map(function(gTracking) {
          const polyline = L.polyline(gTracking.path, {
            color: gTracking.strokeColor,
            weight: gTracking.strokeWeight,
            opacity: gTracking.strokeOpacity
          });
          const decorator = createDecorator(gTracking, polyline);
          LeafletService.addToMap(polyline, 'propriedade-map');
          LeafletService.addToMap(decorator, 'propriedade-map');
          return [polyline, decorator];
        });
      }
    });
  }

  function createDecorator(tracking, polyline) {
    const decorator = L.polylineDecorator(polyline, {
      patterns: [
        {
          offset: 20,
          repeat: 50,
          symbol: L.Symbol.arrowHead({
            pixelSize: 7,
            polygon: false,
            pathOptions: {
              stroke: true,
              color: tracking.strokeColor
            }
          })
        }
      ]
    });
    return decorator;
  }

  function load(filters) {
    TrackingService.users(filters).then(function(usersTracking) {
      $scope.userTrackings = usersTracking.data;
    }, function() {
      MessagesService.alert('Falha ao carregar caminhamentos.');
    });
  }

  $scope.$on('reset', reset);

  $scope.$on('$routeUpdate', function() {
    if (!($routeParams.historyDate || $routeParams.date) || !!$routeParams.summaryStand) {
      reset();
    }
  });

  function reset() {
    $scope.userTrackings = [];
    $scope.removeAllTrackings();
  }

  $scope.$watch('gleba', function(gleba) {
    reset();
    if (gleba && !$routeParams.summaryStand) {
      return load({
        gleba,
        dia: $routeParams.historyDate || $routeParams.date
      });
    }
  });

  $scope.showButton = () => $scope.$parent.isActivityActive() && $scope.userTrackings.length;
});
